<div class="container-fluid" style="padding-left: 0px;">
    <div class="row wrapper">
        <div class="col-lg-2 sidenav">
            <app-sidenav-bar></app-sidenav-bar>
        </div>
        <div class="col-lg-10 bodyContainer">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>